// @owners { team: patients-team }
import { SPACING } from '@alto/design-library-tokens';
import { Description, Icon, Row, SmPadding, XsPadding, XsSpacing, XxsPadding } from '@alto/design-system';
import React from 'react';
import { ActivityIndicator } from 'react-native';
import { useCartNextAvailableDate } from '~shared/features/cart/hooks/useCartNextAvailableDate';
import { formattedNextAvailableDate } from '~shared/features/next-available-date/helpers/formattedNextAvailableDate';
import { useEssentialsCartThreshold } from '../../essentials';

type Props = {
  readonly hideNextAvailableDate?: boolean;
};
export const CartFooterDescriptionText = ({ hideNextAvailableDate }: Props) => {
  const { orderMinimumRemainder, showEssentialsThreshold, minimumFooterCopy, updatingPricing } =
    useEssentialsCartThreshold();
  const { earliestAvailableDate, earliestAvailableDateReason } = useCartNextAvailableDate();
  const isOutOfStockWithNoRecoveryDate = earliestAvailableDateReason === 'oos' && !earliestAvailableDate;
  const refreshing = (
    <XsPadding topPadding={SPACING.STATIC.NONE}>
      <Row centerHorizontally>
        <ActivityIndicator />
        <XsSpacing />
        <Description>Refreshing...</Description>
      </Row>
    </XsPadding>
  );

  if (showEssentialsThreshold) {
    if (updatingPricing) {
      return refreshing;
    }

    return (
      <XsPadding topPadding={SPACING.STATIC.NONE}>
        <Description center>
          {minimumFooterCopy} <Description fontFamily="semibold">${orderMinimumRemainder}</Description> more to checkout
        </Description>
      </XsPadding>
    );
  }

  if (hideNextAvailableDate || isOutOfStockWithNoRecoveryDate) {
    return null;
  }

  if (earliestAvailableDate && earliestAvailableDateReason) {
    return (
      <SmPadding topPadding={SPACING.STATIC.NONE}>
        <Row
          centerHorizontally
          centerVertically
        >
          <Icon
            name="calendar-small"
            type="grey"
          />
          <XxsPadding />
          <Description center>
            {formattedNextAvailableDate(earliestAvailableDate, earliestAvailableDateReason)}
          </Description>
        </Row>
      </SmPadding>
    );
  }

  return refreshing;
};
